import type { AllRouteEndpoints } from "../routeTypes";
export const engagementAppGroupIdTestSendCacheKeys: AllRouteEndpoints[] = [];

export const engagementTestSendCacheKey = "/engagement/:app_group_id/test_send";
